import { render } from "./DocsList.vue?vue&type=template&id=5db6805c&scoped=true&ts=true"
import script from "./DocsList.vue?vue&type=script&lang=ts"
export * from "./DocsList.vue?vue&type=script&lang=ts"

import "./DocsList.vue?vue&type=style&index=0&id=5db6805c&lang=css"
import "./DocsList.vue?vue&type=style&index=1&id=5db6805c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db6805c"]])

export default __exports__